import React,{Component} from 'react';
import '../../CSS/style.css';
export default class SlidersDots extends Component{
    render(){
        const { index, images, turn, type } = this.props;
        const propIndex = index;
        return (
            <div
                style={{ zIndex: 3 }}
                className={type === 'customer' ?"dots_Customer":"dots"}
            >
                {
                    images.map((item,index)=>(
                        <span
                            key={index}
                            className={"dot "+(index === propIndex ? 'active' : '')}
                            onClick={type === 'customer' ? ()=>this.props.turn(index) : ()=>this.props.turn(index-propIndex)}
                            style={{ borderRadius: '100%', cursor: 'pointer' }}
                        >
                        </span>
                    ))
                }
            </div>
        )
    }
}